import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PolicySection.module.css';

function PolicySection() {
  const { t } = useTranslation();
  const cards = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
    titleKey: 'policy.deposit',
    subtitleKey: 'policy.depositDesc',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    titleKey: 'policy.noPassportRetention',
    subtitleKey: 'policy.noPassportRetentionDesc',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    ),
    titleKey: 'policy.clearAgreement',
    subtitleKey: 'policy.clearAgreementDesc',
  },
];

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{t('policy.heading')}</h2>
      <p className={styles.subheading}>
        {t('policy.subheading')}
      </p>
      <div className={styles.grid}>
        {cards.map((card, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.icon}>
              {card.icon}
            </div>
            <h3 className={styles.title}>{t(card.titleKey)}</h3>
            <p className={styles.subtitle}>{t(card.subtitleKey)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PolicySection;
